// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__37CWE","gfeWrapper":"CalendarEvent_gfeWrapper__24JCp"};